export const COUNTRY_OPTIONS = [
  { value: "NO", label: "Norge" },
  { value: "SE", label: "Sverige" },
  { value: "DK", label: "Danmark" },
  { value: "FI", label: "Finland" },
  { value: "DE", label: "Tyskland" },
  { value: "GB", label: "Storbritannia" },
  { value: "NL", label: "Nederland" },
  { value: "PL", label: "Polen" },
  { value: "US", label: "USA" },
];

export const DEFAULT_COUNTRY = "NO";

const ALIASES = {
  norge: "NO",
  norway: "NO",
  no: "NO",
  sverige: "SE",
  sweden: "SE",
  se: "SE",
  danmark: "DK",
  denmark: "DK",
  dk: "DK",
};

export function normalizeCountryCode(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^[A-Za-z]{2}$/.test(raw)) return raw.toUpperCase();
  return ALIASES[raw.toLowerCase()] || raw;
}

export function isCompleteDeliveryAddress(address) {
  if (!address) return false;
  if (address.complete_for_shipping === true) return true;
  if (address.complete_for_shipping === false) return false;
  const fields = [address.name, address.address, address.postal, address.place];
  if (!fields.every((value) => String(value || "").trim().length > 0)) {
    return false;
  }
  const country = normalizeCountryCode(address.country || address.country_code);
  return /^[A-Z]{2}$/.test(country);
}
